import React from 'react';
import { Anchor } from '@atlassiansox/bxp-content-framework';
import { useAnalytics } from '../../components';
export default function UiLink({
  model: {
    id,
    content: {
      text,
      url
    }
  }
}) {
  const {
    sendTrackEvent
  } = useAnalytics();
  return /*#__PURE__*/React.createElement(Anchor, {
    href: url,
    onClick: () => sendTrackEvent('clickedUiLink', {
      event: 'clicked',
      eventComponent: 'link',
      eventContainer: 'content',
      label: text,
      uuid: id,
      href: url
    }),
    "data-uuid": id
  }, text);
}